<template>
  <div class="cash-withdrawal">
    <div class="nav acea-row">
      <!-- @click="swichNav(index, item)" -->
      <div
        v-for="(item, index) in navList"
        class="item font-color-red"
        :key="index"
      >
        <!-- :class="currentTab === index ? 'on' : ''" -->
        <div class="line bg-color-red on"></div>
        <!-- :class="item.icon + ' ' + (currentTab === index ? 'on' : '')" -->
        <div class="iconfont on" :class="item.icon"></div>
        <div>{{ item.name }}</div>
      </div>
    </div>
    <div class="wrapper">
      <div :hidden="currentTab !== 0" class="list">
        <div class="item acea-row row-between-wrapper">
          <div class="name">持卡人</div>
          <div class="input">
            <input placeholder="请输入持卡人姓名" v-model="post.name" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">卡号</div>
          <div class="input">
            <input placeholder="请填写卡号" v-model="post.cardnum" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">银行</div>
          <div class="input">
            <select v-model="post.bankname">
              <option value="">请选择银行</option>
              <option
                v-for="(item, index) in banks"
                :key="index"
                value="item"
                >{{ item }}</option
              >
            </select>
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">提现</div>
          <div class="input">
            <input
              :placeholder="'最低提现金额' + minPrice"
              v-model="post.money"
            />
          </div>
        </div>
        <!-- <div class="tip">当前可提现金额: {{ commissionCount }}</div>
        <div class="bnt bg-color-red" @click="submitted">提现</div> -->
      </div>
      <div :hidden="currentTab !== 1" class="list">
        <div class="item acea-row row-between-wrapper">
          <div class="name">微信号</div>
          <div class="input">
            <input placeholder="请输入微信号" v-model="post.weixin" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">提现</div>
          <div class="input">
            <input
              :placeholder="'最低提现金额' + minPrice"
              v-model="post.money"
            />
          </div>
        </div>
        <!-- <div class="tip">当前可提现金额: {{ commissionCount }}</div>
        <div class="bnt bg-color-red" @click="submitted">提现</div> -->
      </div>
      <div :hidden="currentTab !== 2" class="list">
        <div class="item acea-row row-between-wrapper">
          <div class="name">用户名</div>
          <div class="input">
            <input placeholder="请填写您的支付宝用户名" v-model="post.name" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">账号</div>
          <div class="input">
            <input
              placeholder="请填写您的支付宝账号"
              v-model="post.alipay_code"
            />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">提现</div>
          <div class="input">
            <input
              :placeholder="'最低提现金额' + minPrice"
              v-model="post.money"
            />
          </div>
        </div>
        <!-- <div class="tip">当前可提现金额: {{ commissionCount }}</div>
        <div class="bnt bg-color-red" @click="submitted">提现</div> -->
      </div>
      <div class="list">
        <div class="tip" v-if="$route.query.type == 'brokerage_price'">
          当前可提现金额: {{ commissionCount }}
        </div>
        <div class="tip" v-else>
          当前可提现金额: {{ commissionCountNowMoney }}
        </div>
        <div class="tip" v-if="$route.query.type == 'brokerage_price'">
          手续费: {{ serverPrice }}%
        </div>
        <div class="tip" v-if="$route.query.type == 'now_money'">
          手续费: {{ serverPrice_yue }}%
        </div>
        <div class="bnt bg-color-red" @click="submitted('')">提现</div>
      </div>
    </div>
    <div class="mask acea-row row-center-wrapper" v-if="sercerShow">
      <div class="mask_com">
        <div class="mask_title">温馨提示</div>
        <div class="com_com" v-if="$route.query.type == 'brokerage_price'">
          本次提现手续费比例为{{ serverPrice }}%
        </div>
        <div class="com_com" v-if="$route.query.type == 'now_money'">
          本次提现手续费比例为{{ serverPrice_yue }}%
        </div>
        <div class="but_box  acea-row">
          <div class="but" @click="sercerShow = false">取消</div>
          <div class="but but_right" @click="submitted(true)">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBank, postCashInfo } from "../../../api/user";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
export default {
  name: "UserCash",
  components: {},
  props: {},
  data: function() {
    return {
      navList: [
        // { name: "银行卡", type: "bank", icon: "icon-yinhangqia" },
        // { name: "微信", type: "weixin", icon: "icon-weixin2" },
        { name: "支付宝", type: "alipay", icon: "icon-icon34" }
      ],
      post: {
        extract_type: "alipay",
        alipay_code: "",
        money: "",
        name: "",
        bankname: "",
        cardnum: "",
        weixin: ""
      },
      currentTab: 2,
      commissionCountNowMoney: 0,
      minPrice: 0,
      banks: [],
      commissionCount: 0,
      serverPrice: 0,
      sercerShow: false,
      serverPrice_yue: 0
    };
  },
  mounted: function() {
    this.getBank();
  },
  methods: {
    swichNav: function(index, item) {
      this.currentTab = index;
      this.post.extract_type = item.type;
    },
    getBank: function() {
      let that = this;
      getBank().then(
        res => {
          that.banks = res.data.extractBank;
          that.minPrice = res.data.minPrice;
          that.commissionCountNowMoney = res.data.commissionCountNowMoney;
          that.commissionCount = res.data.commissionCount;
          that.serverPrice = res.data.serverPrice;
          that.serverPrice_yue = res.data.serverPrice_yue;
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },
    async submitted(show) {
      let bankname = this.post.bankname,
        alipay_code = this.post.alipay_code,
        money = this.post.money,
        name = this.post.name,
        cardnum = this.post.cardnum,
        weixin = this.post.weixin,
        that = this;
      if (
        (parseFloat(money) > parseFloat(that.commissionCount) ||
          parseFloat(that.commissionCount) == 0) &&
        this.$route.query.type == "brokerage_price"
      )
        return that.$dialog.message("余额不足");
      if (
        (parseFloat(money) > parseFloat(that.commissionCountNowMoney) ||
          parseFloat(that.commissionCountNowMoney) == 0) &&
        this.$route.query.type == "now_money"
      )
        return that.$dialog.message("余额不足");
      if (parseFloat(money) < parseFloat(that.minPrice))
        return that.$dialog.message("最低提现金额" + that.minPrice);
      if (!show) {
        that.sercerShow = true;
        return;
      }
      that.sercerShow = false;
      switch (that.post.extract_type) {
        case "bank":
          try {
            await this.$validator({
              name: [required.message("持卡人姓名")],
              cardnum: [required(required.message("卡号"))],
              bankname: [required(required("请选择提现银行"))],
              money: [required.message("提现金额")]
            }).validate({ bankname, cardnum, name, money });
            let save = {
              extract_type: that.post.extract_type,
              type: that.$route.query.type,
              bankname: bankname,
              cardnum: cardnum,
              name: name,
              money: money
            };
            that.save(save);
          } catch (e) {
            return validatorDefaultCatch(e);
          }
          break;
        case "alipay":
          try {
            await this.$validator({
              name: [required(required.message("支付宝用户名"))],
              alipay_code: [required(required.message("支付宝账号"))],
              money: [required(required.message("提现金额"))]
            }).validate({ name, alipay_code, money });
            let save = {
              type: that.$route.query.type,
              extract_type: that.post.extract_type,
              alipay_code: alipay_code,
              name: name,
              money: money
            };
            that.save(save);
          } catch (e) {
            return validatorDefaultCatch(e);
          }
          break;
        case "weixin":
          try {
            await this.$validator({
              weixin: [required(required.message("提现微信号"))],
              money: [required(required.message("提现金额"))]
            }).validate({ weixin, money });
            let save = {
              type: that.$route.query.type,
              extract_type: that.post.extract_type,
              weixin: weixin,
              money: money
            };
            that.save(save);
          } catch (e) {
            return validatorDefaultCatch(e);
          }
          break;
      }
    },
    save: function(info) {
      postCashInfo(info).then(
        res => {
          this.$dialog.message(res.msg);
          setTimeout(() => {
            this.$router.go(-1);
          }, 1500);
          // this.$router.push({ path: "/user/audit" });
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
<style scoped lang="scss">
.mask_com {
  padding-top: 10px;
  border-radius: 6px;
  background-color: #fff;
  width: 80%;
  text-align: center;
  .mask_title {
    font-size: 15px;
    margin-bottom: 10px;
  }
  .com_com {
    margin: 10px 10px 20px 10px;
  }
  .but_box {
    border-top: 1px solid #ccc;
    .but {
      flex: 1;
      padding: 10px;
      &.but_right {
        border-left: 1px solid #ccc;
        color: blue;
      }
    }
  }
}
</style>
